import { useContext, useMemo } from 'react'
import { object, func, string, oneOfType, number } from 'prop-types'
import { useSelector } from 'react-redux'
import { CvsAutoComplete } from '@components'
import { fieldSetContext } from '@contexts'
import { Transform } from '../transform'
import { t } from '@lingui/core/macro'

export const Autofill = ({ form, setForm, fieldSetId, disabled, templateId }) => {
  const { byId } = useContext(fieldSetContext)
  const templateFieldsById = useSelector(state => state.Template.templateFieldsById)
  const fields = fieldSetId
    ? useMemo(() => byId[fieldSetId]?.fields?.filter(f => f.id !== form.id), [byId, fieldSetId])
    : useMemo(
        () =>
          Object.values(templateFieldsById)
            .map(tf => tf.field)
            .filter(
              field =>
                field &&
                field.segment_type !== 'variable' &&
                !field.is_pattern &&
                !field.segment_parent_field_id &&
                field.governance_type !== 'link',
            ),
        [templateFieldsById, templateId],
      )

  return (
    <>
      <CvsAutoComplete
        name="autofill-field"
        margin="dense"
        label={t`Select field`}
        disabled={disabled}
        required={true}
        options={fields.map(({ name, id }) => ({ label: name, value: id }))}
        onSelected={value =>
          setForm(prev => ({
            ...prev,
            autofill: { ...prev.autofill, field_id: value, type: 'field', governable_id: prev.id },
          }))
        }
        selected={(form.autofill && form.autofill?.field_id) || ''}
      />
      <Transform form={form} setForm={setForm} />
    </>
  )
}

Autofill.propTypes = {
  form: object.isRequired,
  setForm: func.isRequired,
  fieldSetId: oneOfType([string, number]).isRequired,
}
